export default "__VITE_PUBLIC_ASSET__77fbf932__"